import { GetProgrammaticCampaignTopCreativePerformanceRO } from "@intentsify/dto";
import { apiService, Endpoints } from "api";
import { DisplayPerformanceFilters } from "screens/CampaignPacing/screens/DisplayPerformance";

export const topCreativePerformance = async (
  id: string,
  filters: DisplayPerformanceFilters
): Promise<GetProgrammaticCampaignTopCreativePerformanceRO> => {
  const { data } = await apiService.get(
    Endpoints.ProgrammaticCampaigns.ImpressionsAndClicks.Get.TopCreativePerformance(
      id
    ),
    {
      params: {
        yearFrom: filters.yearFrom,
        yearTo: filters.yearTo,
        weekFrom: filters.weekFrom,
        weekTo: filters.weekTo,
      },
    }
  );

  return data;
};
